<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/3FwyJj/tc-custom/9780813139074.jpg?1703827418245" alt="This image is the cover for the book You've Come a Long Way, Baby"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">You've Come a Long Way, Baby
      </h1>
      <p class="bookDescription body article font2">
        <p><b>“Provocative and diverse” essays on the image—and the reality—of feminism in the twenty-first century (Christine A. Kelly, author of <i>Tangled Up in Red, White, and Blue</i>).</b><br/>  <br/> No matter what brand of feminism one may subscribe to, one thing is indisputable: the role of women in society during the past several decades has changed dramatically, and continues to change in a variety of ways. In <i>You’ve Come a Long Way, Baby,</i> Lilly J. Goren and an impressive group of contributors explore the remarkable advancement achieved by American women in a historically patriarchal social and political landscape, while examining where women stand today and contemplating the future challenges they face worldwide. As comprehensive as it is accessible, <i>You’ve Come a Long Way, Baby</i> appeals to anyone interested in confronting the struggles and celebrating the achievements of women in modern society.<br/>  <br/> “Some of the articles are down-to-earth, some are down-and-dirty. Some are matter-of-fact, others deliberately argumentative in tone. The book itself is a treasury.” —<i>Lincoln County News</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lilly J. Goren
      </h2>
      
      <p class="authorDescription body article">Lilly J. Goren is associate professor of politics and global studies at Carroll University in Waukesha, Wisconsin.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University Press of Kentucky
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?046618b2